<template>
  <div class="page-static " :class="`page-static-${nid}`" ref="pageWrapper">
    <div class="top-wrapper" ref="pageTopWrapper">
      <div class="title">{{node.title}}</div>
    </div>

    <article class="node node-type-article">
      <div class="page-body-wrapper" ref="pageBodyWrapper">
        <article class="node node-type-article">
          <div class="article-parent-wrapper">
            <page-body :nid="nid"></page-body>
            <div></div>
          </div>
        </article>
      </div>
    </article>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import map from 'lodash/map'
  import PageBody from 'components/node/page/PageBody.vue'

  import { freezeFixedPosition } from 'mixins/utilities'

  import { mapActions } from 'vuex'

  export default {
    props: ['nid'],
    data() {
      return {
        headerBgColor: '#dc3a35',
        navigation: false,
      }
    },
    components: {
      PageBody,
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
    },
    mounted() {
      this.autoHeaderTitleToggle(false)
      freezeFixedPosition(true)
      this.navigation = get(this, '$parent.$parent.$refs.header.$refs.navbar.$el', false)
      this.navigation.classList.add('inpage-menu')
      setTimeout(() => {
        this.navigation.classList.add('inpage')
      }, 800)
      this.toggleHeaderTitle(true)
    },
    destroyed() {
      freezeFixedPosition(false)
      this.navigation.classList.remove('inpage')
      this.navigation.classList.remove('inpage-menu')
      this.autoHeaderTitleToggle(true)
    },
    asyncData ({ store, context, props }) {
      if (get(context, 'node')) {
        const nodes = {}
        nodes[context.nid] = context.node
        const nodePromises = map(nodes, item => store.dispatch('nodeFormatter', item))
        return Promise.all(nodePromises)
      }
      if (get(props, 'nid')) { return store.dispatch('fetchNode', { isServerSide: context.isServerSide, nid: props.nid }) }
      return Promise.resolve()
    },
    methods: {
      ...mapActions(['toggleHeaderTitle', 'autoHeaderTitleToggle']),
    },
  }

</script>

<style lang="scss" scoped>
  .page-static {
    background: $cg-red;
    @include respond-to('mobile') {
      display: block;
    }
    .top-wrapper {
      background: $cg-red;
      width: 100%;
      .title {
        font-family: $bungee-inline;
        font-size: rem-calc(100);
        color: $white;
        max-width: rem-calc(700);
        position: relative;
        margin: auto;
        padding: rem-calc(69 0 26 0);
        line-height: rem-calc(102);
        @include respond-to('mobile') {
          font-size: rem-calc(36);
          padding: rem-calc(60 27 26 27);
          line-height: rem-calc(35);
        }
      }
    }

    .node-type-article {
      font-family: $barlow;
      .article-parent-wrapper {
        position: relative;
        background: $white;
        z-index: 1;
        height: 100%;
        padding-bottom: $footer-spacing-top;
      }
    }
  }
</style>

<style lang="scss">
  #header nav.navigation{
    &.inpage {
      background: $cg-red;
    }

    &.inpage-menu {
      @include respond-to('desktop') {
        height: rem-calc(68);
        .navigation__hamburgerMenu {
          top: 50%;
          transform: translateY(-50%);
          height: initial;
        }
        .overlay-header{

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GenericPage.vue?b529c0bc